import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3XS']};
  padding: ${Spacing.S};
  border-radius: ${Spacing['2XS']};
  background-color: ${Colors.Blue10};
`

export const Header = styled.div`
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  display: flex;
  gap: ${Spacing['3XS']};
  color: ${Colors.Blue60};
`

export const Body = styled.div`
  ${Typography.Body};
`
